// @core/api/endpoints/team/get_role_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RoleScheduleResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get role schedule
 * Retrieves role schedule by the specified identifier.
 */
export async function GetRoleSchedule(
  team_id: string,
  schedule_id: string,
  options?: RequestOptions
): Promise<RoleScheduleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/schedules/:schedule_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.get<RoleScheduleResponse>(requestPath, { ...requestOptions });
}
